export default __webpack_public_path__ + "static/media/transicaoIcone.40af26ba.svg";